import { render } from "./selfie-contest.vue?vue&type=template&id=2808368e&lang=pug"
import script from "./selfie-contest.vue?vue&type=script&lang=js"
export * from "./selfie-contest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__